import React, { Component } from 'react';
import CryptoJS from 'crypto-js';
import { QRCode } from 'react-qrcode-logo';
import qrcodeLogo from '../../../images/qrcode_logo.png';
import '../../../scss/components/qrcord_card.scss';
class ShowQRCode extends Component {
  render() {
    var key = CryptoJS.enc.Utf8.parse('6k3k4jbt3hacncxvwj2zpapdpgnhmegd');  //需要和伺服器端一致，否則… 無法解密
    var iv = CryptoJS.enc.Utf8.parse('axgrpang8kekvcj2');   //需要和伺服器端一致，否則… 無法解密
    var aesEncryDecry = {
        decryptStringAES: function (strEncryptText) {
            var decrypted = CryptoJS.AES.decrypt(strEncryptText, key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        },
        encryptStringAES: function (strOrignText) {
            var encrypted = CryptoJS.AES.encrypt(strOrignText, key,{
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        }
    };

    let result = aesEncryDecry.encryptStringAES(localStorage.getItem('username'))
    return (
      <div className="qr-display" style={{ textAlign:'center'}}>
        <QRCode
          value={result} 
          size={150} 
          padding={0} 
          logoImage={qrcodeLogo}
        />
      </div>
    )
  }
}



export default ShowQRCode